module.exports = __webpack_public_path__ + "static/media/kontakt-obrazok.97141081.png";